import Vue from 'vue';
import Vuex from 'vuex';

import archive from './archive';
import auth from './auth';
import certifiedTraining from './certified-training';
import core from './core';
import dbExport from './db-export';
import exchangeBuy from './exchange/buy';
import exchangeDashboard from './exchange/dashboard';
import exchangeDetail from './exchange/detail';
import exchangeSell from './exchange/sell';
import myAccount from './my-account';
import operatorLogs from './operator-logs';
import preScreeningDashboard from './pre-screening/dashboard';
import preScreeningDetailKyc from './pre-screening/detail-kyc';
import preScreeningKyb from './pre-screening/kyb';
import preScreeningKyc from './pre-screening/kyc';
import rbtmDashboard from './rbtm/dashboard';
import rbtmDetail from './rbtm/detail';
import riskAssessmentAssign from './risk-assessment/assign';
import riskAssessmentCdd from './risk-assessment/cdd';
import riskAssessmentDashboard from './risk-assessment/dashboard';
import riskAssessmentDetail from './risk-assessment/detail';
import riskAssessmentEdd from './risk-assessment/edd';
import sarDashboard from './sar/dashboard';
import sarDetail from './sar/detail';
import sarManage from './sar/manage';
import sarNew from './sar/new';
import txsScenario from './txs-scenario';
import userManagement from './user-management';
import vasp from './vasp';
import vc from './vc';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    archive,
    auth,
    certifiedTraining,
    core,
    dbExport,
    exchangeBuy,
    exchangeDashboard,
    exchangeDetail,
    exchangeSell,
    myAccount,
    operatorLogs,
    preScreeningDashboard,
    preScreeningDetailKyc,
    preScreeningKyb,
    preScreeningKyc,
    rbtmDashboard,
    rbtmDetail,
    riskAssessmentAssign,
    riskAssessmentCdd,
    riskAssessmentDashboard,
    riskAssessmentDetail,
    riskAssessmentEdd,
    sarDashboard,
    sarDetail,
    sarManage,
    sarNew,
    txsScenario,
    userManagement,
    vasp,
    vc,
  },
});
